<template>
      <v-alert v-if="isOverallCapExceeded" class="my-8" elevation="3" type="warning" dense prominent>
      <v-container>
        <h6 class="text-h6">{{$t('common.warning')}}</h6>
        {{$t('lds.capReachedAlert')}}: <PricesDisplay
          :prices="amountExceeded"
          :contractCurrencies="contract.currencies"
          :chosenCurrency="contract.chosenCurrency"
          :itemCurrency="capCurrency"
        />
      </v-container>
    </v-alert>
</template>

<script>
export default {
  name: 'LiquidatedDamagesAlert',
  props: {
    contract: Object,
    liquidatedDamages: Array,
    capFromAdjustedContractPrice: Object
  },
  computed: {
    capCents () {
      return this.contract.liquidatedDamagesCap.valueCents
    },
    capCurrency () {
      return this.contract.currencies.find(i => i.key === this.contract.liquidatedDamagesCap.currency) || this.contract.currencies[0]
    },
    liquidatedDamagesSumBaseCurrency () {
      return this.liquidatedDamages.reduce((accumulator, ld) => {
        const part = ld.partId ? this.contract.parts.find(part => part.id === ld.partId) : null
        const currency = part ? this.contract.currencies.find(currency => currency.key === part.currency) : this.contract.currencies[0]
        return accumulator + ld.totalValueCents * currency.value
      }, 0)
    },
    liquidatedDamagesSumCapCurrency () {
      return this.liquidatedDamagesSumBaseCurrency / this.capCurrency.value
    },
    amountLeftBeforeReachingCap () {
      return this.capCents ? this.capCents - this.liquidatedDamagesSumCapCurrency : this.capFromAdjustedContractPrice.sum * this.capCurrency.value - this.liquidatedDamagesSumCapCurrency
    },
    isOverallCapExceeded () {
      return this.amountLeftBeforeReachingCap < 0
    },
    amountExceeded () {
      return this.isOverallCapExceeded ? Math.abs(this.amountLeftBeforeReachingCap) : 0
    }
  }
}
</script>
